import { Button } from 'primereact/button'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

export const NameDisplay = styled(Button)`
    width: unset;
    color: #ffffff;
    background-color: #ce0000;
    border: 2px solid #ce0000;
    border-radius: 6px;
    font-size: 18px;
    font-weight: 800;
    text-transform: uppercase;
    pointer-events: none;
`
